import { type FC } from 'react';
import { checkAllPermissions, PERMISSIONS } from '../permissions';
import useAuth from '../hooks/useAuth';

export interface PermissionRenderProps {
  permission: keyof typeof PERMISSIONS;
  children: React.ReactNode;
}

const PermissionRender: FC<PermissionRenderProps> = ({ permission, children }) => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];
  const hasPermission = checkAllPermissions(userPermissions, [PERMISSIONS[permission].name]);

  if (!hasPermission) {
    return null;
  }

  return <>{children}</>;
};

PermissionRender.displayName = 'PermissionRender';

export default PermissionRender;
